export const PROPERTY_MODEL_TYPE = {
  BORROWER_PROPERTY: 'BorrowerPropertyModel',
  SUBJECT_PROPERTY: 'SubjectPropertyModel',
};

export const initialOtherExpensesState = [{ name: '', value: '' }];
